import { faMars, faVenus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { cancelReservation } from "../apiServices/apiServices";
import { confirmToast } from "./ConfirmToast";

function ItemTicket({
  routeName,
  passengerName,
  gender,
  pickupStopName,
  dropoffStopName,
  seatNo,
  bookingDate,
  pickupLat,
  pickupLon,
  dropOffLat,
  dropOffLon,
  pickupStopId,
  dropoffStopId,
  routeId,
  reservationId,
  status,
  reOrder = false,
  cancel = false,
  onRefresh,
}) {
  const navigate = useNavigate();
  const user_readable_name = routeName;

  const handleReOrder = () => {
    const data = {
      pickupLat,
      pickupLon,
      pickupStopName,
      dropOffLat,
      dropOffLon,
      dropoffStopName,
      gender,
      pickupStopId,
      dropoffStopId,
      user_readable_name,
      routeId,
    };
    // console.log("Data : ", data)
    navigate("/reserveSeats", { state: { reorderData: data } });
  };

  const handleCancel = () => {
    cancelSeat();
  };

  const cancelSeat = async () => {
    try {
      console.log("reservationId:", reservationId);
      const response = await cancelReservation(reservationId);
      console.log("cancelReservation API Response:", response);
      if (response && response.success) {
        toast.success("Successfully canceled your booking.");
        onRefresh();
      } else {
        toast.error(response?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Error occurred:", error);
      toast.error("An error occurred. Please try again.");
    }
  };

  return (
    <div className="flex justify-center mb-4">
      <div className="w-full rounded-lg shadow-md">
        <div className="flex flex-row">
          <div className="p-2 w-2/3 bg-white rounded-l-lg">
            <div
              className={`${status == "RESERVED" ? "bg-[#BE1F18]" : "bg-gray-500"} font-bold text-white text-xs md:text-sm px-2 py-1 mt-2`}
            >
              {routeName ? routeName : "BOARDING PASS"}
            </div>
            <div className="flex mt-2">
              {/* Left Column */}
              <div className="w-1/2 pr-2">
                <div className="mb-5">
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm`}
                  >
                    PASSENGER:
                  </p>
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm font-bold uppercase truncate`}
                  >
                    {passengerName || "Passenger Name"}
                  </p>
                </div>
                <div className="mb-4">
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm mt-2`}
                  >
                    TYPE:
                  </p>
                  <div className="flex space-x-2">
                    {gender === "m" ? (
                      <FontAwesomeIcon
                        icon={faMars}
                        color="#06b6d4"
                        size="lg"
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={faVenus}
                        color="#ec4899"
                        size="lg"
                      />
                    )}
                  </div>
                </div>
                {status == "CANCELED" && (
                  <div className="mb-4 bg-gray-100 justify-items-center border border-black border-dashed">
                    <p className="text-[#BE1F18] text-xs md:text-sm mt-2 mb-2">
                      {status}
                    </p>
                  </div>
                )}
                {reOrder && (
                  <button
                    className="w-full mt-2 mb-2 px-2 py-1 border uppercase font-semibold border-[#BE1F18] text-[#BE1F18] hover:bg-[#BE1F18] hover:text-white text-xs rounded"
                    onClick={handleReOrder}
                  >
                    Re-Order
                  </button>
                )}
                {cancel && status == "RESERVED" && (
                  <button
                    className="w-full mt-2 mb-2 px-2 py-1 border uppercase font-semibold border-[#BE1F18] text-[#BE1F18] hover:bg-[#BE1F18] hover:text-white text-xs rounded"
                    onClick={async () => {
                      const confirmed = await confirmToast(
                        "Are you sure you wish to cancel this reservation?",
                      );
                      if (confirmed) {
                        handleCancel();
                      }
                    }}
                  >
                    Cancel
                  </button>
                )}
              </div>

              {/* Right Column */}
              <div className="w-1/2 mt-0">
                <div className="mb-5">
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm`}
                  >
                    ORIGIN:
                  </p>
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm font-bold uppercase truncate`}
                  >
                    {pickupStopName || ""}
                  </p>
                </div>
                <div className="mb-5">
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm mt-2`}
                  >
                    DESTINATION:
                  </p>
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm font-bold uppercase truncate`}
                  >
                    {dropoffStopName || ""}
                  </p>
                </div>
                <div>
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm mt-2`}
                  >
                    SEAT:
                  </p>
                  <p
                    className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} text-xs md:text-sm font-bold uppercase truncate`}
                  >
                    {seatNo || "01"}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="w-px bg-gradient-to-b from-transparent via-[#BE1F18] to-transparent mx-1 hidden lg:block"></div>
          <div
            className={`${status == "RESERVED" ? "bg-[#BE1F18]" : "bg-gray-500"} p-2 w-1/3 rounded-r-lg`}
          >
            <div
              className={`${status == "RESERVED" ? "text-[#BE1F18]" : "text-gray-500"} font-old bg-white text-xs md:text-sm px-2 py-1 mx-auto mt-2 text-center`}
            >
              ECO. CLASS
            </div>
            <div className="mt-2">
              <p className="text-white text-xxs md:text-xs">PASSENGER:</p>
              <p className="text-white text-xs md:text-sm font-bold uppercase truncate">
                {passengerName || "Passenger Name"}
              </p>
            </div>
            <div className="mt-2">
              <p className="text-white text-xxs md:text-xs">DATE:</p>
              <p className="text-white text-xs md:text-sm font-bold uppercase truncate">
                {bookingDate ? moment(bookingDate).format("DD/MM/YYYY") : ""}
              </p>
            </div>
            <div className="mt-2">
              <p className="text-white text-xxs md:text-xs">DESTINATION:</p>
              <p className="text-white text-xs md:text-sm font-bold uppercase truncate">
                {dropoffStopName || ""}
              </p>
            </div>
            <div className="mt-2 mb-2">
              <p className="text-white text-xxs md:text-xs">SEAT:</p>
              <p className="text-white text-xs md:text-sm font-bold uppercase truncate">
                {seatNo || "01"}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

ItemTicket.propTypes = {
  routeName: PropTypes.string,
  passengerName: PropTypes.string,
  gender: PropTypes.string,
  pickupStopName: PropTypes.string,
  dropoffStopName: PropTypes.string,
  seatNo: PropTypes.string,
  bookingDate: PropTypes.string,
};

export default ItemTicket;
